import {
  PRODUCT_TRANSACTION_EXPORT_LOG_ALL,
  PRODUCT_TRANSACTION_EXPORT_LOG_GET,
  PRODUCT_TRANSACTION_EXPORT_LOG_ERROR,
  PRODUCT_TRANSACTION_EXPORT_LOG_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const productTransactionExportLogAll = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = '',
      page = 1,
      transactionType = '',
      startDate = '',
      endDate = '',
      DashBoardDaily = '',
      DashBoardPage = false,
      selectDate = '',
      statusDocText = '',
      statusReturnText = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-log-export?name=${name}&size=${size}&page=${page}&status=${statusDocText}&status_return=${statusReturnText}&type=${transactionType}&startDate=${startDate}&endDate=${endDate}&DashBoardDaily=${DashBoardDaily}&DashBoardPage=${DashBoardPage}&selectDate=${selectDate}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_ERROR });
    throw new Error(error);
  }
};

export const productTransactionExportLogReset = () => async (dispatch) => {
  try {
    const data = [];
    dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_RESET, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_ERROR });
    throw new Error(error);
  }
};

export const productTransactionExportLogGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-log-export/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_EXPORT_LOG_ERROR });
    throw new Error(error);
  }
};
